import { registerQuery } from 'data-fetching-client';
import { fetchAdCampaignReferencesByIds, fetchAdGroupReferencesByIds, fetchAdReferencesByIds, fetchCTAReferencesByGuidIds, fetchEmailCampaignReferencesByIds, fetchFormReferencesByIds, fetchPageReferencesById, fetchWorkflowReferencesByIds } from 'flow-doctor-lib/utils/legacyReferenceResolvers';
const LEGACY_RESOLVER_MAP = {
  AD: fetchAdReferencesByIds,
  AD_CAMPAIGN: fetchAdCampaignReferencesByIds,
  AD_GROUP: fetchAdGroupReferencesByIds,
  AUTOMATION_PLATFORM_WORKFLOWS: fetchWorkflowReferencesByIds,
  CTA_GUID: fetchCTAReferencesByGuidIds,
  EMAIL_CAMPAIGN: fetchEmailCampaignReferencesByIds,
  FORM: fetchFormReferencesByIds,
  SITE_CONTENT: fetchPageReferencesById
};
export const GET_LEGACY_REFERENCE_LABELS_BY_IDS = registerQuery({
  fieldName: 'legacyReferenceLabelsByIds',
  args: ['portalId', 'referenceType', 'ids'],
  fetcher({
    portalId,
    referenceType,
    ids
  }) {
    if (referenceType in LEGACY_RESOLVER_MAP) {
      return LEGACY_RESOLVER_MAP[referenceType](portalId, ids);
    }
    console.warn('Requested `referenceType` not in LEGACY_RESOLVER_MAP:', referenceType);
    return Promise.resolve({});
  }
});